module.exports = __webpack_public_path__ + "img/orders.1dd5ae13.svg";